import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/exportacao`

    return {
        index(queryParms) {
            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        destroy(id, queryParms) {
            return repository.delete(`${baseUrl}/${id}?${urlUtil.serialize(queryParms)}`)
        },
        download(id) {
            return repository.get(`${baseUrl}/${id}/download`, {responseType: 'arraybuffer'})
        },
        getFichas(queryParms) {
            return repository.get(`${baseUrl}/ficha?${urlUtil.serialize(queryParms)}`)
        },
    }
}